import React, { useState } from "react";
import styled from "styled-components";
import sambaBackground from "../assets/platform-bg.jpeg";
import { Flex } from "samba-ui";

const StyledBox = styled(Flex)`
  background: linear-gradient(#574d9e, #212530);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -10;
`;

const StyledImage = styled.img`
  display: none;
`;

const BgBox = styled.div`
  width: 100%;
  height: 100%;
  opacity: ${p => (p.loaded ? 1 : 0)};
  transition: opacity 1s ease-in;
  ${p => (p.loaded ? `background: url(${p.src}) repeat center center;` : "")};
  background-size: cover;
`;

const BackgroundBox = () => {
  const [loaded, setLoaded] = useState(false);

  const handleImageLoaded = () => {
    setLoaded(true);
  };

  return (
    <StyledBox justifyContent="center" alignItems="center">
      <StyledImage src={sambaBackground} onLoad={handleImageLoaded} />
      <BgBox src={sambaBackground} loaded={loaded} />
    </StyledBox>
  );
};

export default BackgroundBox;
